import { __spreadArray } from "tslib";
import { useSession } from '../components/video/session-provider';
import { useVideoConfig } from '../components/video/video-config-provider';
import { createArray } from '../utils/array';
var VIDEOS_PER_PAGE = 16;
var VIDEOS_PER_PAGE_MOBILE = 4;
export var useGridLayout = function (currentPage) {
    var mobile = useVideoConfig().mobile;
    var _a = useSession(), attendees = _a.attendees, currentAttendeeId = _a.currentAttendeeId, focusedAttendeeId = _a.focusedAttendeeId;
    var videosPerPage = mobile ? VIDEOS_PER_PAGE_MOBILE : VIDEOS_PER_PAGE;
    var pagesCount = Math.ceil(attendees.length / videosPerPage);
    var visibleAttendeeIds = getVisibleAttendeeIds(attendees, currentAttendeeId, focusedAttendeeId, pagesCount, currentPage, videosPerPage);
    var sortedAttendeeIds = attendees
        .slice()
        .sort(function (attendeeIdA, attendeeIdB) { return visibleAttendeeIds.indexOf(attendeeIdA) - visibleAttendeeIds.indexOf(attendeeIdB); });
    return {
        attendees: sortedAttendeeIds,
        pagesCount: pagesCount,
        visibleAttendeeIds: visibleAttendeeIds,
        focusedAttendeeId: focusedAttendeeId,
    };
};
var getVisibleAttendeeIds = function (attendees, currentAttendeeId, activeAttendeeId, pagesCount, currentPage, videosPerPage) {
    var activeAttendeesCount = 2; // focused and current
    var nonActiveAttendees = attendees.filter(function (attendeeId) { return attendeeId !== currentAttendeeId && activeAttendeeId !== attendeeId; });
    if (pagesCount === 1) {
        return createArray(videosPerPage).map(function (_, i) { return attendees[i]; });
    }
    if (currentPage === 0) {
        return __spreadArray([
            currentAttendeeId,
            activeAttendeeId
        ], createArray(videosPerPage - activeAttendeesCount).map(function (_, i) { return nonActiveAttendees[i]; }), true);
    }
    return createArray(videosPerPage).map(function (_, i) { return nonActiveAttendees[currentPage * videosPerPage + i - activeAttendeesCount]; });
};
//# sourceMappingURL=grid-layout.js.map